import { render, staticRenderFns } from "./make-detail-table.vue?vue&type=template&id=663f2b80&scoped=true&"
import script from "./make-detail-table.vue?vue&type=script&lang=js&"
export * from "./make-detail-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "663f2b80",
  null
  
)

export default component.exports